module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine platform in United Kingdom.05c97792.webp";